import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Redux
import { useSelector, useDispatch, } from 'react-redux';
import { announcementDetail, 
    exportAnnouncementToPdf,
    exportAnnouncementToXml 
} from '../../store/actions/announcement';

import { Table, 
        OverlayTrigger,
        Tooltip,
        Row,
        Col,
        Button
} from 'react-bootstrap';

import { Loader, truncateText, formatNumber, isSubscriptionActive, shouldShowPaymentAlert } from '../../utils/tools';
import { FREE_PLAN } from '../../config/plans';
import { activityCodeDescriptions } from '../../utils/constants/activityCodes';
import PaymentAlert from '../../utils/paymentAlert';

const AnnouncementDetail = () => {

    const location = useLocation();
    const dispatch = useDispatch();
    
    const tenant = useSelector(state => state.tenant.current);
    const isActive = isSubscriptionActive(tenant?.subscriptionStatus, tenant?.plan);

    const { year, activityCode } = location.state || {}

    const currentBranch = useSelector(state => state.branch.current);

    useEffect(() => {
        if (currentBranch !== '') dispatch(announcementDetail({currentBranch, year, activityCode}));
    }, [dispatch, currentBranch, year, activityCode]);

    const announcement = useSelector(state => state.announcement.detail);
    const loading = useSelector(state => state.announcement.loading);
  
    // Render Tooltips
    const renderTooltipWasteName = (props, wasteName) => (
        <Tooltip id="button-tooltip" {...props}>
            {wasteName}
        </Tooltip>
    );

    const renderTooltipCompanyName = (props, companyName) => (
        <Tooltip id="button-tooltip" {...props}>
            {companyName}
        </Tooltip>
    );

    // Handlers
    const handlePdfExport = () => {
        dispatch(exportAnnouncementToPdf({currentBranch, announcement, year, activityCode, tenantName: tenant?.companyName}));
    }

    const handleXmlExport = () => {
        dispatch(exportAnnouncementToXml({currentBranch, announcement, year, activityCode, tenantName: tenant?.companyName}));
    }

    return (
        <>
            { loading ?
                <div style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    height: '35vh' 
                }}>
                    <Loader/>
                </div>
            :
            <div>

                <div>
                    <Row>
                        <Col sm="12" md="12">

                            {/* Export to XML */}
                            {tenant?.plan === FREE_PLAN ? (
                                <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip>XML export nie je dostupný pre Demo plán.</Tooltip>}
                                >
                                    <span>
                                        <Button
                                            className="button-export btn-custom-small"
                                            size="sm"
                                            disabled
                                        >Exportovať do XML</Button>
                                    </span>
                                </OverlayTrigger>
                            ) : (
                                <Button
                                    className="button-export btn-custom-small"
                                    size="sm"
                                    disabled={!isActive}
                                    onClick={() => handleXmlExport(currentBranch, announcement, year, activityCode)}
                                >Exportovať do XML</Button>
                            )}

                            {/* Export to PDF */}
                            <Button
                                className="button-export btn-custom-small me-2"
                                size="sm"
                                // disabled={isButtonExportDisabled} 
                                onClick={() => handlePdfExport(currentBranch, announcement, year, activityCode)}
                            >Exportovať do PDF</Button>
                        </Col>
                
                    </Row>
                </div>

                {tenant && shouldShowPaymentAlert(tenant.subscriptionStatus, tenant.plan) && (
                    <PaymentAlert status={tenant.subscriptionStatus} plan={tenant.plan} />
                )}

                <Row className="text-center">
                    <Col>
                        <div>         
                            <span className="text-muted">Typ dokladu</span>
                        </div>
                        <div>
                            <strong>{activityCodeDescriptions[activityCode] || "Neexistujúci typ ohlásenia odpadu"}</strong>
                        </div>
                    </Col>

                   {/* Divider */}
                    <Col xs="auto" className="d-flex align-items-center">
                        <div style={{ width: "1px", height: "100%", backgroundColor: "#ddd" }} />
                    </Col>

                    <Col>
                        <div>
                            <span className="text-muted">Rok</span>
                        </div>
                        <div>
                            <strong>{year}</strong>
                        </div>
                    </Col>
                </Row>

                <div className="content pt-4 pb-4">
                    
                    <Table responsive hover>
                        <thead>
                            <tr>
                                <th className="px-3">Por. číslo</th>
                                <th>Kód odpadu</th>
                                <th>Názov odpadu</th>
                                <th>Kateg. odpadu</th>
                                <th>Y-kód</th>
                                <th>Hmotnosť odpadu</th>
                                <th>Kód</th>
                                <th>Obchodné meno</th>
                                <th>Skratka</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                announcement.map((item, index) => {

                                    const i = index + 1;

                                    return(

                                        <tr key={index}>
                                            <td className="px-3">{i}</td>
                                            <td>{item.wasteCode}</td>
                                            <OverlayTrigger 
                                                placement="top" 
                                                overlay={(props) => renderTooltipWasteName(props, item.wasteName)}
                                                >
                                                    <td>{truncateText(item.wasteName, 8)}</td>
                                            </OverlayTrigger>
                                            <td>{item.wasteCategory}</td>
                                            <td>{item.yCode}</td>
                                            <td>    
                                                {item.balance != null 
                                                    ? new Intl.NumberFormat('sk-SK', { minimumFractionDigits: 0, maximumFractionDigits: 3 }).format(formatNumber(item.balance))
                                                    : item.totalDisposal != null
                                                    ? new Intl.NumberFormat('sk-SK', { minimumFractionDigits: 0, maximumFractionDigits: 3 }).format(formatNumber(item.totalDisposal))
                                                    : item.totalIncome != null
                                                    ? new Intl.NumberFormat('sk-SK', { minimumFractionDigits: 0, maximumFractionDigits: 3 }).format(formatNumber(item.totalIncome))
                                                    : ''
}
                                            </td>
                                            <td>{item.loadingCode}</td>
                                            <OverlayTrigger
                                                placement="top"
                                                overlay={(props) => renderTooltipCompanyName(props, item.client?.companyName ?? '—')}
                                            >
                                                <td>{truncateText(item.client?.companyName ?? '—', 20)}</td>
                                            </OverlayTrigger>
                                            <td>
                                                {item.acronym}
                                            </td>
                                        </tr>
                                    )
                                })
                            }
                        </tbody>
                    </Table>
                </div>
            </div>
            }
        </>
    );
}

export default AnnouncementDetail;